import { ajax } from '../../util'

export function getAuthorSuccess(data: object) {
    return {
        type: 'GET_AUTHOR_SUCCESS',
        data
    }
}

export function loadingAuthor(data: boolean) {
    return {
        type: 'LOADING_AUTHOR',
        data
    }
}

export function getAuthorError(data: string) {
    return {
        type: 'GET_AUTHOR_ERROR',
        data
    }
}

export function getAuthor(secId: any) {
    return (dispatch: any) => {
        dispatch(loadingAuthor(true))
        const url = '/api/author/sec_id=' + secId
        if (secId === '') {
            dispatch(getAuthorSuccess([]))
        } else {
            ajax(url, {}, 'GET').then(res => {
                if (res.hasError) {
                    dispatch(getAuthorError(res[Object.keys(res)[0]]))
                } else {
                    dispatch(getAuthorSuccess(res))
                }
                dispatch(loadingAuthor(false))
            })
        }
    }
}

export function getAuthorReportsSuccess(data: object) {
    return {
        type: 'GET_AUTHOR_REPORTS_SUCCESS',
        data
    }
}

export function gettingAuthorReports(data: boolean) {
    return {
        type: 'GETTING_AUTHOR_REPORTS',
        data
    }
}

export function getAuthorReportsError(data: string) {
    return {
        type: 'GET_AUTHOR_REPORTS_ERROR',
        data
    }
}

export function getAuthorReports(id: string, page: number) {
    return (dispatch: any) => {
        dispatch(gettingAuthorReports(true))
        const url = '/api/author/' + id + '/rr?' + page

        ajax(url, {}, 'GET').then(res => {
            if (res.hasError) {
                dispatch(getAuthorReportsError(res[Object.keys(res)[0]]))
            } else {
                dispatch(getAuthorReportsSuccess(res))
            }
            dispatch(gettingAuthorReports(false))
        })
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/scenes/Analyst/actions.tsx